import { MiddlewareStore } from "store/createStore";
import { IChatMessage } from "store/messages/messages.state";
import * as Logger from '../../../../../services/logger'

export const saveAttachmentId = async (store: MiddlewareStore, message : IChatMessage) => {
    
    try {
        const { contactId, connectionDetails } = store.getState().app;
        const attachmentId = message.attachments?.[0]?.AttachmentId;
        if (!attachmentId) throw new Error('unable to retrieve attachment id');

        const { contactFlowId } = connectionDetails;
        const localAttachmentsPath = `smartagent_signed_attachment_ids/${contactFlowId}`;
        const localAttachmentsIds = localStorage.getItem(localAttachmentsPath);

        if (!localAttachmentsIds)
            throw new Error('unable to retrieve attachment ids from storage');
        const attachmentConfig = JSON.parse(localAttachmentsIds);

        const attachment = await window.bchat.getAttachment({
            contactId: contactId!,
            attachmentID: attachmentId,
        });

        if(!attachment) throw new Error('unable to get attachment key')

        const s3Key = attachment.Url.match('(?<=[a-z-A-Z]/)(.*?)(?=\\?)')?.[0];

        if (!(contactId && attachmentConfig[contactId]))
            throw new Error('unable to find contact Id in attachment');
        attachmentConfig[contactId].push(s3Key);
        localStorage.setItem(localAttachmentsPath, JSON.stringify(attachmentConfig));
    } catch (error) {
        Logger.error('Unable to formulate attachment ids', error)
        console.log('error occured when trying to formulate attachment IDs', error);
    }
}

export const handleAttachment = async (message: IChatMessage, store: MiddlewareStore, session: connect.CustomerChatSession, discard = true) => {
    
    if (message.type !== 'ATTACHMENT' || !message.attachments?.length) return message;

    saveAttachmentId(store, message)

    if (message.role === "CUSTOMER" && discard) {
        message.discarded = true;
        return message
    }
    
    const file = await session.downloadAttachment({ attachmentId: message.attachments[0].AttachmentId });
    const url = window.URL.createObjectURL(file)


    message.content = {
        type: 'FILE_LINK',
        src: url,
        label: message.attachments[0].AttachmentName,
        isImage: file.type.split('/')[0] === 'image',
        fileType: file.type,
        onDownload: () => {
            const downloadLink = document.createElement('a')
            downloadLink.setAttribute('download', message.attachments?.[0]?.AttachmentName ?? 'Download');
            downloadLink.setAttribute('href', url)
            document.body.appendChild(downloadLink);
            downloadLink.click();
            downloadLink.remove();
        },
    };



    return message;

}